import styled from 'styled-components';

export const StyledOrderedList = styled.ol`
  display: contents;
`;
